export default (value) => {
    const date = new Date(value+'T00:00:00')
    return date.toLocaleString(['es-ES'], {month: 'long',
     day: '2-digit', year: 'numeric'})
}                                                                                                                                           


// WEBPACK FOOTER //
// ./src/filtros/fecha.js